export default "__VITE_ASSET__6v8_npxt__"